import { render } from "./App.vue?vue&type=template&id=2cf39a8b&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=2cf39a8b&lang=scss"

import exportComponent from "D:\\fuwumao\\zecai-official-website\\node_modules\\.pnpm\\vue-loader@17.0.1_vue@3.2.45_webpack@5.75.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__